import { RouteConfig } from 'vue-router';

import { permissionRoute } from './roles/permission.route';
import { rolesRoute } from './roles/roles.route';

export const roleContainerRoute: RouteConfig = {
  path: 'role',
  component: () => import(/* webpackChunkName: "RouterView" */ '@/components/appLayout/Router.vue'),
  children: [rolesRoute, permissionRoute],
  redirect: { name: 'roles' },
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'Role',
      name: 'roles'
    },
    config: {
      title: 'Role',
      icon: 'fal fa-sitemap',
      permissions: ['ROLE.LIST'],
      name: 'roles',
      group: 'Użytkownicy'
    }
  }
};
